import React from "react";
import "../assets/styles/card.css"; // import CSS file

const Card = ({
  title,
  description,
  imageUrl,
  place,
  date,
  opponent,
  scored,
  conceded,
}) => {
  return (
    <div className="body">
      <div className="card-container">
        <div className="card-image">
          <img src={imageUrl} alt={title} />
        </div>
        <div className="card-content">
          <h2>{title}</h2>
          <h4>Place : {place}</h4>
          <h4>Date : {date}</h4>
          <h4>Opponents : {opponent}</h4>
          <h4>Goals Scored : {scored}</h4>
          <h4>Goals Conceded : {conceded}</h4>

          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
